import {
  Avatar,
  Box,
  InputBase,
  Stack,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";

export const StyledCommentsSection = styled(Stack)(() => ({
  display: "grid",
  gridTemplateRows: "0fr",
  opacity: 0,
  transform: "translateY(-6px)",
  transition: "grid-template-rows 0.35s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.3s ease, transform 0.3s ease",

  "& > *": {
    minHeight: 0,
    overflow: "hidden"
  },

  "&.visible": {
    gridTemplateRows: "1fr",
    opacity: 1,
    transform: "translateY(0)"
  }
}));
export const CommentInputBase = styled(InputBase)(({ theme }) => ({
  "& .MuiInputBase-input": {
    backgroundColor: theme.customColors.backgroundSecondary,
    borderRadius: "0.5rem",
    border: `0.0625rem solid ${theme.customColors.border}`,
    color: theme.customColors.textInput,
    gap:theme.spacing(1),
    padding:  theme.spacing(1, 5, 1, 2),

    "&::placeholder ":{
      color:theme.customColors.backgroundDisabled,
      fontFamily:"Inter",
      fontWeight:400,
      lineHeight: "21px",
      opacity:1,
      [theme.breakpoints.down("sm")]: {
        fontSize:"14px",
        lineHeight: "8px",
        width:"158px"
      }
    }
  },
  width: "100%"
}));

export const ForbiddenLabelTypography = styled(Typography)(({ theme }) => ({
  color: theme.customColors.textWarning,
  fontSize: "10px",
  fontWeight: "700"
}));

export const CommentInputRow = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    alignItems: "end",
    flexDirection: "column"
  }
}));

export const CommentInputInnerStack = styled(Stack)(({ theme }) => ({
  [theme.breakpoints.down("sm")]: {
    width: "100%"
  }
}));

export const CommentSectionAvatar = styled(Avatar)(({ theme }) => ({
  color: theme.customColors.headerIcon
}));

export const CommentInputBox = styled(Box)(() => ({
  borderRadius: "0.5rem",
  flexGrow: 1,
  overflow: "hidden"
}));
